import { useNavigate } from 'react-router-dom';
import { Button, Panel, secondaryTextClassName } from '@monecolier/ui';

interface EnrollmentKpiCardProps {
  to: string;
  testId: string;
  icon: string;
  label: string;
  labelClassName?: string;
  value: number;
  description: string;
  linkLabel: string;
}

/**
 * UX-44 — EXTRAIT de `StudentsOverview.tsx` (UX-18, seule implémentation
 * avant ce ticket) : `Home.tsx` en devient le SECOND consommateur réel,
 * jamais une seconde présentation divergente des cartes "À traiter"/"Liste
 * d'attente" (markup/classes STRICTEMENT INCHANGÉS par l'extraction).
 *
 * UX-67 — ⚠️ **ANCIEN patron corrigé** : la carte entière était enveloppée
 * dans un `<Link>`, avec un texte `linkClassName` en pied de carte imitant
 * visuellement un bouton sans jamais en être un (juste un `<p>`). Un vrai
 * `<button>` ne peut PAS s'imbriquer dans un `<a>` (HTML invalide) — la
 * carte n'est donc plus enveloppée dans un `Link` : SEUL le `<Button>` du
 * pied de carte reste cliquable, choix documenté plutôt que deviné (voir
 * docs/history/UX.md, section "UX-67") : la zone de clic se réduit du panneau entier
 * au bouton, mais un vrai bouton accessible (rôle, focus clavier natif) vaut
 * mieux qu'une zone de clic large et invisible pour qui ne survole pas
 * toute la carte.
 */
export function EnrollmentKpiCard({
  to,
  testId,
  icon,
  label,
  labelClassName,
  value,
  description,
  linkLabel,
}: EnrollmentKpiCardProps) {
  const navigate = useNavigate();
  return (
    <div data-testid={testId}>
      <Panel>
        <p className={`text-xs font-semibold uppercase tracking-wide ${labelClassName ?? 'text-gray-500'}`}>
          <span aria-hidden="true">{icon}</span> {label}
        </p>
        <p className="mt-1 text-3xl font-semibold text-gray-900">{value}</p>
        <p className={secondaryTextClassName}>{description}</p>
        <Button type="button" variant="primary" size="small" className="mt-2" onClick={() => navigate(to)}>
          {linkLabel} →
        </Button>
      </Panel>
    </div>
  );
}
